import { useState } from 'react'
import { LaunchDarkly } from '@truepill/tpos-types'
import { ReactComponent as LocationIcon } from 'assets/icons/location.svg'
import IconWrapper from 'components/IconWrapper'
import MultiSelect from 'components/MultiSelect'
import useEnforceOtcLocation from 'hooks/useEnforceOtcLocation'
import { useFlag } from 'providers/LaunchDarklyProvider'
import { useTPCacheContext } from 'providers/TPCacheProvider'
import { usePlusClient } from 'providers/VisionRouter'

type LocationSelectProps = {
  label?: string
  variant?: 'small' | 'large'
  disabled?: boolean
}

const LocationSelect = (props: LocationSelectProps): JSX.Element => {
  const displayDashboardDesignV2: boolean = useFlag(LaunchDarkly.FeatureFlags.TPOS_DASHBOARD_DESIGN_V2) ?? false

  const { variant = 'large', disabled } = props
  const { currentLocation, routeToMergedQuery } = usePlusClient()
  const { locations } = useTPCacheContext()

  useEnforceOtcLocation()

  const locationIds = currentLocation?.queryMap?.locationIds?.length
    ? currentLocation.queryMap.locationIds
    : currentLocation?.queryMap?.locationId
    ? [currentLocation.queryMap.locationId]
    : []

  const [selectedOptions, setSelectedOptions] = useState<string[]>(locationIds)

  const allOption = {
    label: 'All locations',
    value: '',
    selectAll: true,
  }

  const locationOptions = Object.values(locations)
    .filter(location => location.active)
    .map(value => ({
      label: value.name,
      value: value._id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
    .sort((a, b) =>
      selectedOptions.includes(a.value) && !selectedOptions.includes(b.value)
        ? -1
        : selectedOptions.includes(b.value) && !selectedOptions.includes(a.value)
        ? 1
        : 0,
    )

  const options = [allOption, ...locationOptions]

  return (
    <MultiSelect
      disabled={disabled}
      css={{
        ul: { maxHeight: '21rem' },
        ...(displayDashboardDesignV2 && variant === 'small' && { width: '14rem' }),
      }}
      onChange={values => {
        setSelectedOptions(values)
        if (values.includes(allOption.value)) {
          routeToMergedQuery({ locationIds: [], locationId: undefined })
        } else {
          routeToMergedQuery({ locationIds: values, locationId: undefined })
        }
      }}
      options={options}
      placeholder="Select locations"
      renderOptions={{ displayQuantity: true }}
      startAdornment={() =>
        displayDashboardDesignV2 ? (
          <IconWrapper>
            <LocationIcon fill={'black'} />
          </IconWrapper>
        ) : (
          <></>
        )
      }
      value={selectedOptions}
      variant={variant}
    />
  )
}

export default LocationSelect
